
import { createSlice } from '@reduxjs/toolkit';
import Actor from '@/types/actor';
import Voice from '@/types/voice';
import { VideoState } from '@/types/video';

const initialState: VideoState = {
  listingUrl: null,
  actor: {} as Actor,
  voice: {} as Voice,
  script: {
    approved: false,
    content: '',
  },
  email: '',
  scriptAudio: null,
};

export const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    setVideoListingUrl: (state, action) => {
      state.listingUrl = action.payload;
    },
    setVideoActor: (state, action) => {
      state.actor = action.payload;
      state.voice = action.payload.voice || {};
    },
    setVideoVoice: (state, action) => {
      state.voice = action.payload;
      state.scriptAudio = null;
    },
    setVideoScript: (state, action) => {
      state.script = {
        approved: false,
        content: action.payload
      };
    },
    setVideoScriptApproved: (state, action) => {
      state.script.approved = action.payload;
    },
    setVideoEmail: (state, action) => {
      state.email = action.payload;
    },
    clearScriptAudio: (state) => {
      state.scriptAudio = null;
    },
    resetVideo: () => {
      return initialState;
    },
  },
});

export const { setVideoListingUrl, setVideoActor, setVideoVoice, setVideoScript, setVideoScriptApproved, setVideoEmail, resetVideo, clearScriptAudio } = videoSlice.actions;

export default videoSlice.reducer;
